import * as yup from "yup";
import { Language } from "../../language/English";

export const PaymentValidation = () => {
    return yup.object().shape({
        enablePayment : yup.boolean().required().label(Language.BOOKING_PAYMENT_TYPE),
        bookingFeeType : yup.number().required(Language.BOOKING_FEE_TYPE_REQUIRED).typeError(Language.BOOKING_FEE_TYPE_VALID).label(Language.BOOKING_FEE_TYPE),
        paymentType : yup.number().required(Language.BOOKING_PAYMENT_TYPE).typeError(Language.BOOKING_PAYMENT_TYPE).label(Language.BOOKING_FEE_TYPE),
    });
}